import React from "react";
import ReactGA from "react-ga";
import PropTypes from 'prop-types';

const debug = import.meta.env.MODE !== 'production';
export const GoogleAnalyticsContext = React.createContext(null);

export function GoogleAnalyticsContextProvider({ children }) {

    return (
        <GoogleAnalyticsContext.Provider value={{
            ReactGA
        }}>
            { children }
        </GoogleAnalyticsContext.Provider>
    );
}

GoogleAnalyticsContextProvider.propTypes = {
    children: PropTypes.node.isRequired
};


export const Analytics = {
    initializeOrgaTracker: (id=null) => {
        // If widget has tracking info we should set it and create a new tracker
        if(!id) {
            return;
        }

        ReactGA.initialize(id, {
            gaOptions: {
                name: 'orgaTracker',
            },
            debug
        });
    },
    event: (event) => {
        ReactGA.event(event, ['orgaTracker']);
    },
    pageview: (path) => {
        ReactGA.pageview(path, ['orgaTracker']);
    }
}

